import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { scrollToCheckout } from '../utils/scroll';
type StickyBarProps = {
  visible: boolean;
};
export function StickyBar({
  visible
}: StickyBarProps) {
  return <AnimatePresence data-id="element-123" data-mp="xth8kv5bbp2j">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50" data-id="element-124" data-mp="svp8hduikwn9">
          <div className="mx-auto flex max-w-[480px] items-center justify-between gap-4 border-t border-gold/25 bg-ink/80 px-5 py-3 backdrop-blur-md" data-id="element-125" data-mp="jty6aiz6n7y5">
            <p className="whitespace-nowrap text-sm font-semibold text-white" data-id="element-126" data-mp="9wteo3mkik9y">
              <span className="font-serif text-base" data-id="element-127" data-mp="9yxt3fi3f1oh">ELEGIDA</span>
              <span className="text-muted" data-id="element-128" data-mp="298mf6a8ke7rf"> · </span>
              <span className="text-gold" data-id="element-129" data-mp="24aumvf40cjmp">$97 USD</span>
            </p>
            <button type="button" onClick={scrollToCheckout} className="whitespace-nowrap rounded-lg bg-gold px-6 py-3 text-sm font-bold uppercase tracking-wide text-ink shadow-gold transition-transform duration-150 ease-out hover:scale-[1.02] active:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-130" data-mp="24bnjhn995sr4">
              Reservar
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}